/**
 * Pinia 注册入口
 * 含持久化插件（pinia-plugin-persistedstate）
 * 具体 store 切片（machine/order/ad/product/push）留给 E.4 实装
 */

import type { App } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export function setupPinia(app: App): void {
  app.use(pinia)
}

export { pinia }
